import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';

import { FormHelper } from '../../helpers/form-helper';
import { Application } from '../../models/application';
import { Payment } from '../../models/payment';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.component.html',
  styleUrls: ['./add-payment.component.scss']
})
export class AddPaymentComponent extends FormHelper implements OnInit {
	private application: Application;

	constructor(private dialogRef: MdDialogRef<AddPaymentComponent>,
							private formBuilder: FormBuilder,
							private applicationService: ApplicationService) {
		super();

		this.buildForm();
	}

  ngOnInit() {
  }

	public buildForm(): void {
		this.form = this.formBuilder.group({
			amount: new FormControl('', Validators.required),
			reference: new FormControl('', Validators.required)
		});
	}

	public updateForm(application: Application): void {
		this.application = application;
	}

	public submitForm(): void {
		const payment: Payment = this.form.value;
		payment.hasSponsorship = false;

		if (Number.isFinite(payment.amount)) {
			this.applicationService.addPayment(this.application.$key, payment);
			this.dialogRef.close();
		}
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/add-payment/add-payment.component.ts